import { Component, OnInit, AfterViewInit, ViewChild, ViewEncapsulation, OnDestroy, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { LocalStorageService } from '../../../services/infrastructure/local-storage.service';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { CppPriceListService } from '../../../services/cpp/cpp-price-list.service';
import { MasterConstants } from '../../../common/constants/master-constants';
import { CPPPriceListFilter } from '../../../models/CPP/CPPPriceListFilter';
import { DashboardFilter } from '../../../models/DashboardFilter';
import { MatTableDataSource } from '@angular/material/table';
import { CppManageSubscription } from '../../../services/cpp/cpp-price-list-manage-subscription.service';
import { Subscription, forkJoin } from 'rxjs';

@Component({
  selector: 'app-cpp-customer-price-list',
  templateUrl: './cpp-customer-price-list.component.html',
  styleUrls: ['./cpp-customer-price-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CppCustomerPriceListComponent implements OnInit, AfterViewInit, OnDestroy {

  //Array variables
  subscription = new Array<Subscription>();
  priceListCPPColumns: string[] = ['Customer', 'contextMenu'];
  searchTypeList = ['Customer Name'];
  priceListAccounts: any = [];
  cPPPricedList: any = [];
  selectedValue: string = this.searchTypeList[0];
  CPPPricedListDataSource: MatTableDataSource<any>;

  //Object Type Variables
  productFilters: CPPPriceListFilter = new CPPPriceListFilter();
  filter: CPPPriceListFilter = new CPPPriceListFilter();

  //Value Variables
  headerYear: any;
  dashboardFilter: DashboardFilter;
  searchAccountNo: number;
  isManageSubscription = false;
  isMobile = /Android|iPhone/i.test(window.navigator.userAgent);
  headerValue: string = "";
  emptyGridMsg: string = "";

  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private cppPriceListService: CppPriceListService,
    private cppManageSubscription: CppManageSubscription) {
    this.dashboardFilter = new DashboardFilter();
    if (this.isMobile) {
      this.headerValue =  "Accounts";
      this.emptyGridMsg = "No record Found.";
    } else {
      this.headerValue = "Available Price Lists";
      this.emptyGridMsg = "No PriceList found.";
    }
  }

  ngOnInit() {
    // Set the default value
    this.cppPriceListService.accountName = '';
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }
    this.resetPageFilter();
    this.getCppPriceList();
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setPriceListTableHeight();
  }

  // Called after component's view is fully intialised
  ngAfterViewInit() {
    this.setPriceListTableHeight();
  }

  // Set Table height dynamically
  setPriceListTableHeight() {
    setTimeout(function () {
      const templateHeight = window.innerHeight - $('.topSection').outerHeight() - 120;
      $('.priceListTable').css('max-height', templateHeight + 'px');
    }, 100);
  }

  // Get Cpp orders list
  getCppPriceList() {
    this.loaderService.setLoaderStatus(true);
    const forkJoinAPIs = [];
    forkJoinAPIs.push(this.cppPriceListService.getCppCustomerPriceList());
    forkJoinAPIs.push(this.cppManageSubscription.isValidForSubscription());
    this.subscription.push(forkJoin(forkJoinAPIs).subscribe((result: any[]) => {
      if (this.isMobile && result[0]) {
        result[0] = result[0].filter(x => x.accountType?.toLowerCase() != "pl" || x.accountNumber === MasterConstants.UsNationalAccount);
      }
      this.cPPPricedList = result[0];
      this.priceListAccounts = result[0];
      this.isManageSubscription = result[1];
      this.CPPPricedListDataSource = new MatTableDataSource(this.cPPPricedList);
      this.loaderService.setLoaderStatus(false);
      if (this.priceListAccounts && this.priceListAccounts.length === 1) {
        this.cppPriceListService.accountName = this.priceListAccounts[0].accountName;
        const accountNumber = this.priceListAccounts[0].accountNumber;
        if (this.isMobile) {
          this.router.navigate(['/pricelistLookup/cpp-price-list-lookup-grid/' + accountNumber]);
        } else {
          this.router.navigate(['/cpp/price-list-dashboard/' + accountNumber]);
        }
        
      }
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }


  // Filter the records on basis of account number
  filterRecords() {
    if (this.searchAccountNo && this.searchAccountNo > 0) {
      const filteredList = this.cPPPricedList.filter(x => x.accountNumber == this.searchAccountNo);
      this.CPPPricedListDataSource = new MatTableDataSource(filteredList);
    }
    else {
      this.CPPPricedListDataSource = new MatTableDataSource(this.cPPPricedList);
    }
  }

  // Reset Page Filter
  resetPageFilter() {
    this.productFilters = new CPPPriceListFilter();
    this.filter = new CPPPriceListFilter();
  }

  // Redirect to product page
  redirectToProduct(accountNo, accountName) {
    this.cppPriceListService.accountName = accountName;
    if (this.isMobile) {
      this.router.navigate(['/pricelistLookup/cpp-price-list-lookup-grid/' + accountNo]);
    } else {
      this.router.navigate(['/cpp/price-list-dashboard/' + accountNo]);
    }
    
    this.setPriceListTableHeight();
  }

  // Redirect to Subscription page
  redirectToSubscription(accountNo, accountName) {
    this.cppPriceListService.accountName = accountName;
    this.router.navigate(['/cpp/price-list-manage-subscription/' + accountNo]);
    this.setPriceListTableHeight();
  }

  // Search the account details on shipto / Deliverto dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1;
  }

  public ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
